import type { NbisMenuItemsProps } from 'presentation/view/components/NavigationMenu/NbisNavigationMenuItems';
import styled from 'styled-components';
import { Background7, HPHGreyDark, HPHSkyBlue, MontserratFont } from 'veronica-ui-component/dist/component/core/Colors';
const AngleRightIcon = require('veronica-ui-component/dist/assets/Icon/Icon-angle-right.svg').default;


export const StyledMain = styled.ul`
    &.dropdown{
        display: none;
    }
    &.show{
        display: block;
        max-height: calc(100vh - 5px);
    }
    background:${Background7};
    font-family: ${MontserratFont}; 
    border-radius: 8px;
    width: 15rem;
    padding:0.75rem 0;
    position: absolute;
    left: 100%;
    top: 0;
    color:${HPHGreyDark};
    border: 1px solid #dee2e6;
    margin: 0;
    list-style: none;
    cursor: default;
    z-index: 1000;
`;

export const StyledNav = styled.nav`
    position:relative;
    width:32px;
    >button {
        div{
            width:32px;
            height: 32px;
        }
    }
`;

export const StyledMainWrapper = styled.li<NbisMenuItemsProps>`
    position: relative;
    list-style: none;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;s
    justify-content: space-between;
    cursor:pointer;
    &.separator{
        border-top: 1px solid #dee2e6;
        margin: 0.25rem 0;
    }
`;

export const StyledButton = styled.button<NbisMenuItemsProps>`
    background: none;
    border: none;
    font-family: ${MontserratFont}; 
    font-size: 1rem;
    font-weight: 400;
    white-space: nowrap;
    padding: 0.75rem 1.4rem;
    width: 100%;
    white-space: pre;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items:center;
    line-height:1.2;
    &.isActive{
        background: #F1F2F3;
        outline: none;
        color: ${HPHSkyBlue};
    }
    &:hover{
        background: #F1F2F3;
        outline: none;
        color: ${HPHSkyBlue};
    }
    &::after{
        content: " ";
        mask-image: url(${AngleRightIcon});
        background-color: ${HPHSkyBlue};
        mask-repeat: no-repeat;
        mask-size: 100%;
        width: 1rem;
        height: 1rem;
    }
`;

export const StyledMenuWrapper = styled.ul`
    &.dropdown{
        display: none;
    }
    &.show{
        display: block;
        max-height: 60vh;
    }
    background:${Background7};
    font-family: ${MontserratFont}; 
    border-radius: 8px;
    width: auto;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    padding:0.75rem 0;
    color:${HPHGreyDark};
    border: 1px solid #dee2e6;
    margin: 0;
    position: absolute;
    left: 100%;
    top: auto; 
    bottom: 0; 
    cursor: default;
    z-index: 1000;
`;

export const StyledTitle = styled.a`
    text-decoration: none;
    font-family: "Montserrat",serif;
    font-size: 1rem;
    font-weight: 400;
    white-space: nowrap;
    padding: 0.75rem 1.4rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
    color:${HPHGreyDark};
    &:hover{
        background: #F1F2F3;
        outline: none;
        color: ${HPHSkyBlue};
    }
`;

export const StyledGroup = styled.span`
    display: block;
    font-size: 0.75rem;
    font-weight: bold;
    color:${HPHSkyBlue};
    text-transform: uppercase;
    pointer-events: none;
    cursor: default;
    margin: 15px 0 5px;
    padding: 0 1.5rem;
    font-size: 0.75rem;
    border-radius: 0;
    transition: box-shadow 0.2s;
`;